import api from "../../../api";
import { env } from "../../../env";

const baseurl = env.REACT_APP_API_URL_NEWSLETTER;

class CategoryClient {

    async GetCategories(isBackground) {
        try{
            var response = await api.get(baseurl + "/Category/GetCategories", {isBackground: isBackground})
            return response.data;
        }
        catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
    }

    async GetCategoryById(id, isBackground) {
        try{
            var response = await api.get(baseurl + "/Category/GetCategory?id=" + id, {isBackground: isBackground})
            return response.data;
        }
        catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
    }

    async CreateCategory(data, isBackground) {
        try{
            var response = await api.post(baseurl + "/Category/CreateCategory", data, {isBackground: isBackground})
            return response.data;
        }
        catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
    }

    async UpdateCategory(data, isBackground) {
        try{
            var response = await api.put(baseurl + "/Category/UpdateCategory", data, {isBackground: isBackground})
            return response.data;
        }
        catch (err) {
      if (err.response.status === 400) return err.response.data;
      else return err.response;
    }
    }
}

export default CategoryClient;